<template>
  <div
    class="product-wishlist"
    v-html="wishlistComment"
  />
</template>

<script>

/**
 * Vue: Product wishlist (product-wishlist)
 * -----------------------------------------------------------------------------
 * Handles injecting Wishlist King comments.
 * - All wishlist functionality is achieved in
 *   snippets/appmate-wishlist-king.liquid.
 *
 * @param {Boolean|Object} product - Product object, false shows loading state.
 *
 */
export default {
  name: 'ProductWishlist',

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  computed: {

    /**
     * Return the appropriate Wishlist King button comment.
     * @returns {String}
     */
    wishlistComment() {
      return `<!-- include 'wishlist-button-product' with '${this.product.id}'-->`
    },
  },
}
</script>
